<template>
  <div class="issue-check">
    <subfield>
      <template slot="list">
        <div class="trees">
          <div class="trees-title">{{ $t('cdca1') }}</div>
          <div class="trees-content">
            <ul class="servers">
              <li
                v-for="(item ,index) in KommanderServers"
                :key="item.ks_id"
                class="server-item"
                :class="{'s-i-click': selectIndex === item.ks_id,'is-online': item.run_state === '1'}"
                @click="selectKsId(item, index)"
              >{{index+1}}-{{item.name}}</li>
            </ul>
          </div>
        </div>
      </template>
      <template slot="content">
        <div class="c-up">
          <img class="icon" src="@/assets/images/public/public_return.png" @click="$router.go(-1)" alt />
          <div style="font-size: 20px;">{{ $t('cdca2') }}</div>
          <div class="cu-btn" @click="synchronizeKommanderDevices">{{ $t('cdca3') }}</div>
        </div>
        <div class="c-center">
          <el-table
            ref="multipleTable"
            :data="serverList"
            style="width: 100%"
            @selection-change="selectionChange"
            v-loading="loading"
            :cell-style="synchronizationStatusStyle"
          >
            <el-table-column type="selection" width="60" :selectable="checkSelectable"></el-table-column>
            <el-table-column type="index" :label="$t('cdca4')" width="120"></el-table-column>
            <el-table-column prop="name" :label="$t('terminal.deviceName')"></el-table-column>
            <el-table-column prop="xy" :label="$t('cdca6')"></el-table-column>
            <el-table-column prop="wh" :label="$t('cdca6')"></el-table-column>
            <el-table-column prop="synchronization_status" :label="$t('cdca5')" :formatter="synchronizationStatus"></el-table-column>
          </el-table>
        </div>
        <div class="c-bottom">
          <!-- v-if="current >limit" 当current数据小于limit数据时不需要分页，可直接隐藏分页 -->
          <pagination :current="current" :limit="limit" @currentChange="currentChange"></pagination>
        </div>
      </template>
    </subfield>
  </div>
</template>

<script>
import subfield from '@/components/basics/Subfield'
import pagination from '@/components/basics/Pagination'
import { mPagination } from "@/components/basics/mixins";
export default {
  name: 'IssueCheck',
  mixins: [mPagination],
  data() {
    return {
      serverList: [],
      selectIndex: -1,
      loading: false,
      multipleSelection: [],
      KommanderServers: [],
      selectedKS: null,
      KommanderDevices: null,
      myWebSocket: null
    }
  },
  created() {
    // this.$http.post("/admin/access/groupList", {}, data => {
    //   this.groupList = data;
    // });
    this.getKommanderServers();
    this.myWebSocket = this.$store.getters.myWebSocket;
    this.myWebSocket.onmessage = (msg) => {
      let data = JSON.parse(msg.data);
      console.log(data);
      switch (data.type) {
        case 'kommander_get_devices':
          this.serverList = data.params.devices.map(item => {
            let synchronization_status = 0;
            let sn = `${this.selectedKS.name}@${item.x}x${item.y}@${item.width}x${item.height}`;
            for (let item of this.KommanderDevices) {
              if (item.sn === sn) {
                synchronization_status = 1;
                break;
              }
            }
            return {
              name: item.name,
              xy: `${item.x},${item.y}`,
              wh: `${item.width}*${item.height}`,
              run_state: item.state,
              x: item.x,
              y: item.y,
              sn: sn,
              width: item.width,
              height: item.height,
              synchronization_status: synchronization_status
            };
          });
      }
    };
  },
  methods: {
    currentChange(val) {
      console.log(val);
      // this.getStatusList({ group_id: this.groupId, limit: this.limit, page: val });
    },
    checkSelectable(row) {
      return !row.synchronization_status;
    },
    selectionChange(val) {
      this.multipleSelection = val.map(item => {
        return {
          group_id: this.$cookies.get("group_id"),
          type_id: 2,
          type_remark: "Kommander",
          size_id: `${item.width}x${item.height}`, // w x h
          attr_id: 1,
          attr_remark: "普通",
          user_id: this.$cookies.get("user_id"), // 用户名id
          name: item.name,
          sn: item.sn, // 拼接
          x: item.x,
          y: item.y,
          ks_id: this.selectIndex,
          run_state: item.run_state,
          kommander_server_name: this.selectedKS.name
        };
      });
      console.log(this.multipleSelection);
    },
    synchronizeKommanderDevices() {
      if (this.multipleSelection.length > 0 && !this.loading) {
        this.loading = true;
        this.multipleSelection && this.$http.post("/admin/device/synchronizeKommanderDevices", { devices: encodeURIComponent(JSON.stringify(this.multipleSelection)) }, () => {
          this.selectKsId(this.selectedKS);
        }, true);
      }
    },
    async selectKsId(item) {
      this.selectIndex = item.ks_id;
      this.selectedKS = item;
      await this.$http.post("/admin/device/getKommanderDevices", { ks_id: item.ks_id }, data => {
        console.log(data);
        this.KommanderDevices = data;
      });
      if (parseInt(item.run_state) > 0) {
        let msg = {
          role: 'web',
          from: 'kommander_get_devices',
          data: {
            ks_id: item.ks_id
          }
        };
        this.myWebSocket.send(JSON.stringify(msg));
      } else {
        this.serverList = [];
      }
      this.loading = false;
    },
    getKommanderServers() {
      this.$http.post("/admin/device/getKommanderServers", {}, data => {
        console.log(data);
        let onLine = data.filter(item => item.run_state === '1');
        // eslint-disable-next-line no-unused-vars
        let offLine = data.filter(item => item.run_state === '0');
        // 只显示在线设备
        // this.KommanderServers = [...onLine];
        // 同时显示在线与离线设备
        this.KommanderServers = [...onLine, ...offLine];
      });
    },
    synchronizationStatus(value) {
      console.log(value);
      return value.synchronization_status ? '已同步' : '未同步';
    },
    synchronizationStatusStyle({ row, columnIndex }) {
      if (columnIndex === 5) {
        return row.synchronization_status ? 'color:#00c48f' : 'color:#c90606';
      }
    }
  },
  components: {
    subfield,
    pagination
  }
}
</script>

<style lang="scss" scoped>
.issue-check {
  width: 100%;
  height: 100%;
  .trees {
    width: 190px;
    flex: 1;
    background-color: #fff;
    border-radius: 0px 8px 8px 0px;
    .trees-title {
      width: 190px;
      height: 44px;
      font-size: 16px;
      line-height: 44px;
      text-align: center;
      color: #fff;
      background-image: linear-gradient(
          270deg,
          #86eae7 0%,
          #4cccf0 45%,
          #11adf8 100%
        ),
        linear-gradient(#9fb5da, #9fb5da);
      background-blend-mode: normal, normal;
      border-radius: 0px 8px 0px 0px;
    }
    .trees-content {
      padding-right: 2px;
      overflow-y: scroll;
      // 上线适配
      // max-height: 639px;
      .servers {
        .server-item {
          height: 44px;
          font-size: 16px;
          color: #617883;
          line-height: 44px;
          padding-left: 10px;
          border-left: 6px solid #fff;
          max-width: 188px;
          overflow: hidden;
          color: #c90606;
        }
        .s-i-click {
          border-left: 6px solid #4cccf0;
          background-color: #e5f9fd;
        }
        .is-online {
          color: #00c48f;
        }
      }
    }
  }
  .c-up {
    height: 60px;
    padding: 0px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 18px;
    color: var(--theme-color-customized-1);
    border-bottom: 2px solid #d7ecf3;
    .cu-btn {
      padding: 10px;
    }
  }
  .c-center {
    height: calc(100% - 60px - 60px);
    max-height: (560px);
    overflow-y: scroll;
    /deep/ .cell {
      font-size: 16px;
    }
    /deep/ .el-table__header-wrapper {
      .cell {
        font-size: 18px;
        color: var(--theme-color-customized-1);
      }
    }
  }
  .icon {
    width: 30px;
    height: 30px;
    padding-right: 6px;
  }
}
</style>
